import { IStore } from 'store/configureStore';
import { selectCurrentClientId } from 'store/entities/clients/selectors/clientsSelectors';

export const selectManagerSubmittedSheetsFilters = (state: IStore) => state.components.managerSubmittedSheets.filters;
export const selectManagerSubmittedSheetsFiltersConfiguration = (state: IStore) => {
    const clientId = selectCurrentClientId(state) ?? '';
    return state.clients.fieldsConfigurationByClientId[clientId]?.filters?.manager_sheets;
};
